import intl from "src/internationalization/intl";
import { Accordion, Grid, Typography } from "src/lib";
import { ISummaryProps } from "./types";

const Summary = (props: ISummaryProps) => {
    const opportunitiesClientsCount = props.opportunitiesClientsCount ?? 0
    const totalEventsCount = (props.commitment.clients?.length ?? 0) + opportunitiesClientsCount
    return (
        <Accordion.Summary open={props.open} onToggle={props.onToggle}>
            <Grid container justifyContent="space-between">
                <Typography variant="caption">
                    {props.commitment.due_date}
                </Typography>
                <Grid>
                    <Grid container gap={2}>
                        <Typography>
                            {totalEventsCount.toString()}
                        </Typography>
                        <Typography>
                            {totalEventsCount > 1 ? intl("events") : intl("event")}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Accordion.Summary>
    );
};

export { Summary };
